import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function SendIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg version="1.0" viewBox="0 0 1280.000000 738.000000"
                 preserveAspectRatio="xMidYMid meet">
                <metadata>
                    Created by potrace 1.15, written by Peter Selinger 2001-2017
                </metadata>
                <g transform="translate(0.000000,738.000000) scale(0.100000,-0.100000)" stroke="none">
                    <path d="M12670 7345 c-63 -18 -272 -77 -465 -130 -192 -53 -478 -132 -635
-175 -508 -141 -1091 -302 -2345 -649 -676 -187 -2038 -563 -3025 -836 -987
-273 -2072 -573 -2410 -666 -338 -94 -802 -222 -1030 -285 -1857 -514 -2579
-714 -2684 -742 -38 -10 -65 -21 -60 -24 5 -3 67 -22 139 -41 72 -20 326 -90
565 -157 239 -67 611 -170 825 -230 215 -60 586 -163 825 -230 239 -67 491
-137 560 -156 l126 -34 974 439 c1397 629 4128 1858 6050 2724 910 410 1826
822 2035 917 209 94 387 173 395 176 35 10 -66 -39 -8200 -3928 -586 -280
-1068 -512 -1071 -516 -3 -4 33 -117 82 -252 76 -213 355 -996 765 -2147 65
-183 120 -330 122 -329 1 2 114 558 250 1236 l248 1233 3455 2064 c1900 1135
3670 2193 3933 2351 264 158 491 293 505 301 62 33 -5 -12 -271 -182 -1671
-1070 -7188 -4613 -7188 -4617 0 -7 3661 -2455 3669 -2454 4 1 3713 6853 3977
7347 8 15 11 27 7 26 -5 0 -60 -15 -123 -34z"/>
                    <path d="M5030 2232 c-15 -61 -479 -1861 -531 -2058 -21 -83 -39 -154 -39
-158 0 -3 369 330 820 740 452 411 817 750 813 754 -11 10 -1025 754 -1039
763 -8 4 -16 -10 -24 -41z"/>
                </g>
            </svg>

        </SvgIcon>
    )
}